import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ExpensesPage({ apiUrl, auth, isAdmin, permissions }) {
  const [expenses, setExpenses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editExpense, setEditExpense] = useState(null);
  const [form, setForm] = useState({ description: '', amount: '' });

  const canAdd = isAdmin || permissions.add_expenses;
  const canEdit = isAdmin;
  const canDelete = isAdmin;

  useEffect(() => { loadExpenses(); }, []);

  const loadExpenses = async () => {
    try {
      const res = await axios.get(`${apiUrl}/expenses`);
      setExpenses(res.data);
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const openAdd = () => {
    setEditExpense(null);
    setForm({ description: '', amount: '' });
    setShowModal(true);
  };

  const openEdit = (expense) => {
    if (!canEdit) return;
    setEditExpense(expense);
    setForm({ description: expense.description, amount: String(expense.amount) });
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!form.description || !form.amount) return;
    try {
      if (editExpense) {
        await axios.put(`${apiUrl}/expenses/${editExpense.id}`, {
          description: form.description,
          amount: parseFloat(form.amount)
        });
      } else {
        await axios.post(`${apiUrl}/expenses`, {
          description: form.description,
          amount: parseFloat(form.amount),
          created_by: auth.user.id
        });
      }
      setShowModal(false);
      loadExpenses();
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!canDelete) return;
    if (!window.confirm('Supprimer cette dépense ?')) return;
    try {
      await axios.delete(`${apiUrl}/expenses/${id}`);
      loadExpenses();
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const totalExpenses = expenses.reduce((sum, e) => sum + e.amount, 0);

  return (
    <div>
      <div className="page-header">
        <h1>💰 Dépenses</h1>
        {canAdd && (
          <button className="btn btn-primary" onClick={openAdd}>+ Ajouter une dépense</button>
        )}
      </div>

      <div className="stats-grid">
        <div className="stat-card expense">
          <div className="stat-label">Total des dépenses</div>
          <div className="stat-value">{totalExpenses.toFixed(0)} DA</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Nombre</div>
          <div className="stat-value">{expenses.length}</div>
        </div>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Montant</th>
              <th>Date</th>
              {canEdit && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {expenses.length === 0 ? (
              <tr><td colSpan={canEdit ? 4 : 3} style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary)' }}>Aucune dépense</td></tr>
            ) : (
              expenses.map(expense => (
                <tr key={expense.id}>
                  <td style={{ fontWeight: '600' }}>{expense.description}</td>
                  <td style={{ fontWeight: '700', color: 'var(--danger)' }}>-{expense.amount.toFixed(0)} DA</td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                    {expense.created_at ? new Date(expense.created_at).toLocaleDateString('fr-FR', {
                      day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
                    }) : '-'}
                  </td>
                  {canEdit && (
                    <td>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button className="btn btn-outline btn-sm" onClick={() => openEdit(expense)}>✏️</button>
                        {canDelete && (
                          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(expense.id)}>🗑</button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editExpense ? 'Modifier la dépense' : 'Nouvelle dépense'}</h2>
            <div className="form-group">
              <label>Description</label>
              <input type="text" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Ex: Eau, Nettoyage..." />
            </div>
            <div className="form-group">
              <label>Montant (DA)</label>
              <input type="number" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} placeholder="Ex: 1000" />
            </div>
            <div className="modal-actions">
              <button className="btn btn-outline" onClick={() => setShowModal(false)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleSave}>{editExpense ? 'Modifier' : 'Ajouter'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ExpensesPage;
